/** Matches `InvoiceLetterheadUpdate.letterhead_pdf_data` max_length in the API. */
export const API_LETTERHEAD_PDF_DATA_URL_MAX_LENGTH = 6_000_000;

const MAX_FILE_BYTES = 4 * 1024 * 1024;

function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") resolve(reader.result);
      else reject(new Error("Datei konnte nicht gelesen werden."));
    };
    reader.onerror = () => reject(new Error("Datei konnte nicht gelesen werden."));
    reader.readAsDataURL(file);
  });
}

/**
 * Liest eine PDF-Datei als Data-URL für das Rechnungs-Briefpapier ein.
 */
export async function readPdfFileAsDataUrl(file: File): Promise<string> {
  if (file.type && file.type !== "application/pdf") {
    throw new Error("Bitte wählen Sie eine PDF-Datei.");
  }
  if (!file.name.toLowerCase().endsWith(".pdf")) {
    throw new Error("Bitte wählen Sie eine PDF-Datei.");
  }
  if (file.size > MAX_FILE_BYTES) {
    throw new Error("Die PDF-Datei ist zu groß (max. 4 MB).");
  }

  const dataUrl = await readFileAsDataUrl(file);
  if (!dataUrl.startsWith("data:application/pdf")) {
    throw new Error("Die Datei ist keine gültige PDF.");
  }
  if (dataUrl.length > API_LETTERHEAD_PDF_DATA_URL_MAX_LENGTH) {
    throw new Error("Die PDF-Datei ist nach dem Einlesen zu groß (max. ca. 4 MB).");
  }
  return dataUrl;
}
